export default __webpack_public_path__ + "static/media/map.c579c386.jpg";